import { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
import { BASEAPIURL, get1stDateMonth, getTodayDate, showfulldatetime } from '../../../../../config';
import Pagination from '../MyBlogPagination';
import { Link } from 'react-router-dom';

let SortStatus = 1;

function OrderListAdmin({ forpage }) {
    // for pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(10);
    const [TotalRecords, setTotalRecords] = useState(10);
    const nPages = Math.ceil(TotalRecords / recordsPerPage);
    // for pagination
    const [loading, setLoading] = useState(false);
    const [invoiceIni, setInvoiceIni] = useState("*");
    const [orders, setOrders] = useState([]);
    const [students, setStudents] = useState({});
    const [filters, setFilters] = useState({
        recordsPerPage: 10,
        fromDate: get1stDateMonth(),
        toDate: getTodayDate(),
        PageNumber: 1,
    });

    const FetchOrders = async (filters = {}) => {
        setLoading(true);
        try {
            const res = await fetch(`${BASEAPIURL}/admin/account/fetchOrdersData`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(filters),
            });
            const resJson = await res.json();
            setLoading(false);
            if (res.status === 200) {
                if (resJson.data) {
                    setOrders(resJson.data);
                }
                if (resJson.count) {
                    setTotalRecords(resJson.count);
                }
                if (resJson.invoiceIni) {
                    setInvoiceIni(resJson.invoiceIni);
                }
                if (resJson.students) {
                    setStudents(resJson.students);
                }
            }
        } catch (err) {
            setLoading(false);
            alert(err.message);
        }
    };

    const FetchFilterOrders = async (e, keywordhere, sortbyhere, PageNumber) => {
        e.preventDefault();
        FetchOrders({
            ...filters,
            keyword: keywordhere,
            sortby: sortbyhere,
            PageNumber,
            recordsPerPage
        });
        return false;
    };

    function totalAmount(currencyType) {
        if (!Array.isArray(orders)) return 0;
        // console.log(orders);
        // console.log(currencyType);
        // return 200;
        return orders.reduce((sum, item) => {
            if (item.paymentCurrency === currencyType) {
            return sum + Number(item.receivedAmount || 0);
            }
            return sum;
        }, 0);
    }

    useEffect(() => {
        FetchOrders({
            recordsPerPage: 10,
            fromDate: get1stDateMonth(),
            toDate: getTodayDate(),
            PageNumber: 1
        });
    }, []);

    return (
        <>
            <div
                className="ry_instr_shadow p-4"
                forpage={forpage}
            >
                <h4>Orders</h4>
                <form id="blog_filter_frm" className="row mt-3">
                    <div className="col-md-3">
                        <input
                            name="fromDate"
                            type="date"
                            className="form-control"
                            value={filters.fromDate}
                            onChange={(e) => {
                                setCurrentPage(1);
                                setFilters({ ...filters, fromDate: e.target.value, PageNumber: 1 });
                                FetchOrders({ ...filters, fromDate: e.target.value, PageNumber: 1 });
                            }}
                        />
                    </div>
                    <div className="col-md-3">
                        <input
                            name="toDate"
                            type="date"
                            className="form-control"
                            min={filters.fromDate}
                            value={filters.toDate}
                            onChange={(e) => {
                                setCurrentPage(1);
                                setFilters({ ...filters, toDate: e.target.value, PageNumber: 1 });
                                FetchOrders({ ...filters, toDate: e.target.value, PageNumber: 1 });
                            }}
                        />
                    </div>
                    <div className="col-md-4">
                        <select
                            name="SortStatus"
                            defaultValue={SortStatus}
                            className="form-control"
                            onChangeCapture={(e) => {
                                setCurrentPage(1);
                                setFilters({ ...filters, status: e.target.value, PageNumber: 1 });
                                FetchOrders({ ...filters, status: e.target.value, PageNumber: 1 });
                            }}
                        >
                            <option value="ALL">All</option>
                            <option value="1">Paid</option>
                            <option value="0">Unpaid</option>
                        </select>
                    </div>
                </form>
                <div className={loading ? 'text-center mt-5' : 'd-none'}>
                    <img src="/loader.gif" alt="Fetching Data.." style={{ maxWidth: '60px' }} />
                    <br />
                    Fetching Data..
                </div>
                <div className={loading ? 'd-none' : ''}>
                    <div className="mt-3 table-responsive">
                        <table className="table table-hover table-borddered table-stripped">
                            <thead className="ry-table-header">
                                <tr>
                                    <th>Invoice ID</th>
                                    <th>Student</th>
                                    <th>Payment ID</th>
                                    <th>Amount</th>
                                    <th>Date & Time</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.map((singi) => (
                                    <tr key={singi.blogcatid}>
                                        <td>{invoiceIni}-{singi.orderID}</td>
                                        <td>
                                            <b>{students[singi.studentID].name}</b>
                                            <div><i className="fa fa-envelope"></i> {students[singi.studentID].email}</div>
                                            <div><i className="fa fa-phone"></i> {students[singi.studentID].mobile}</div>
                                        </td>
                                        <td>{singi.paymentID}</td>
                                        <td>
                                            {Number(singi.receivedAmount) ? (
                                                <>{singi.paymentCurrency} {singi.receivedAmount}</>
                                            ) : (
                                                <>NA</>
                                            )}
                                        </td>
                                        <td title={`Updated at ${showfulldatetime(singi.updatedAt)}`}>
                                            {showfulldatetime(singi.createdAt)}
                                        </td>
                                        <td>
                                            {singi.status ? (
                                                <Link to={`/invoice/${singi._id}`} className="btn btn-sm btn-info" target="_INVOICE">
                                                    Invoice
                                                </Link>
                                            ) : (
                                                <button type="button" disabled className="btn btn-sm btn-warning">
                                                    Unpaid
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="row mb-3">
                        <h5 className="col-md-2"></h5>
                        <div className="col-md-4">
                            <h5 className="border p-2 text-center">
                                <small><b>Total AED</b></small>
                                <div className="mt-1">
                                    {totalAmount('AED').toLocaleString()}
                                </div>
                            </h5>
                        </div>
                        <div className="col-md-4">
                            <h5 className="border p-2 text-center">
                                <small><b>Total USD</b></small>
                                <div className="mt-1">
                                    {totalAmount('USD').toLocaleString()}
                                </div>
                            </h5>
                        </div>
                    </div>

                    <small className="text-center d-block mb-2">
                        Showing page {currentPage} of total page {nPages} from {TotalRecords} records.
                    </small>
                    <Pagination
                        nPages={nPages}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        FetchFilterBlogs={FetchFilterOrders}
                        SortBy=""
                        Keyword=""
                    />
                </div>
            </div>
        </>
    );
}

export default OrderListAdmin;
